// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"09876ac9","664":"4619fce0","958":"fbefc681"}[chunkId] + ".chunk.js";
};